import { Plugin } from '@nuxt/types'

const isTouchPlugin: Plugin = ({ $device }) => {
  $device.isTouch = (('ontouchstart' in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0))
}

export default isTouchPlugin
